import { MathUtils, Vector3 } from 'three';

interface GetRotationCoordinatesProps {
  latitude: number;
  longitude: number;
}

const AUSTRALIA_COORDINATES: GetRotationCoordinatesProps = {
  latitude: -22,
  longitude: 145,
};

export const getCoordinatesToRotation = ({
  latitude,
  longitude,
}: GetRotationCoordinatesProps) =>
  new Vector3(-MathUtils.degToRad(latitude), -MathUtils.degToRad(longitude), 0);

export const AUSTRALIA_ROTATION = getCoordinatesToRotation(
  AUSTRALIA_COORDINATES
);
